import Crossword from "../Views/Crossword";

const routes = [{ path: "/crossword", element: <Crossword /> }];

export default routes;
